import { __decorate } from "tslib";
import React, { cloneElement, Component } from 'react';
import { observer } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import isFunction from 'lodash/isFunction';
import noop from 'lodash/noop';
import classNames from 'classnames';
import Icon from 'choerodon-ui/lib/icon';
import { getProPrefixCls as getProPrefixClsDefault, getConfig } from 'choerodon-ui/lib/configure/utils';
import TableButtons from './TableButtons';
import Button from '../../button';
import TableContext from '../TableContext';
import { ButtonColor, FuncType } from '../../button/enum';
import Form from '../../form';
import { LabelLayout } from '../../form/enum';
import { $l } from '../../locale-context';
import autobind from '../../_util/autobind';
import { Tooltip as LabelTooltip } from '../../core/enum';
let TableProfessionalBar = class TableProfessionalBar extends Component {
    constructor() {
        super(...arguments);
        this.openMore = (fields) => {
            const { tableStore } = this.context;
            if (this.moreFields && this.moreFields.length) {
                this.moreFields = [];
            }
            else {
                this.moreFields = fields;
            }
            if (tableStore.node) {
                tableStore.node.handleHeightTypeChange();
            }
            return this.moreFields;
        };
    }
    static get contextType() {
        return TableContext;
    }
    get queryFields() {
        const { queryFields } = this.props;
        return queryFields.filter(component => {
            return !component.props.hidden;
        });
    }
    get prefixCls() {
        const { prefixCls } = this.props;
        const { tableStore: { getProPrefixCls = getProPrefixClsDefault } } = this.context;
        return getProPrefixCls('table', prefixCls);
    }
    componentDidMount() {
        const { queryFieldsLimit, queryFields, queryDataSet, defaultExpanded } = this.props;
        if (queryDataSet && queryFields.length && defaultExpanded) {
            runInAction(() => {
                this.moreFields = this.createFields(queryFields.filter(f => !f.props.hidden).slice(queryFieldsLimit));
            });
        }
        this.processDataSetListener(true);
    }
    componentWillReceiveProps(nextProps, _) {
        const { queryFieldsLimit, queryFields, queryDataSet, defaultExpanded } = nextProps;
        if (queryDataSet && queryFields.length && (defaultExpanded || (this.moreFields && this.moreFields.length))) {
            runInAction(() => {
                this.moreFields = this.createFields(queryFields.filter(f => !f.props.hidden).slice(queryFieldsLimit));
            });
        }
    }
    componentWillUnmount() {
        this.processDataSetListener(false);
    }
    processDataSetListener(flag) {
        const { queryDataSet } = this.props;
        if (queryDataSet) {
            const handler = flag ? queryDataSet.addEventListener : queryDataSet.removeEventListener;
            handler.call(queryDataSet, 'validate', this.handleDataSetValidate);
        }
    }
    /**
     * queryDataSet 查询前校验事件 触发展开动态字段
     * @param dataSet 查询DS
     * @param result
     */
    async handleDataSetValidate({ result }) {
        const { queryFieldsLimit } = this.props;
        const moreFields = this.createFields(this.queryFields.slice(queryFieldsLimit));
        if (!await result) {
            runInAction(() => {
                this.moreFields = moreFields;
            });
        }
    }
    handleFieldEnter() {
        this.handleQuery();
    }
    async handleQuery(collapse) {
        const { dataSet, queryDataSet, onQuery = noop } = this.props;
        if (queryDataSet && await queryDataSet.validate()) {
            await dataSet.query();
            if (!collapse) {
                await onQuery();
            }
        }
    }
    getResetButton() {
        const { prefixCls } = this;
        return (React.createElement(Button, { key: 'lov_reset_btn', className: `${prefixCls}-professional-reset-btn`, funcType: FuncType.raised, onClick: this.handleQueryReset }, $l('Table', 'reset_button')));
    }
    getMoreFieldsButton(fields) {
        const { prefixCls } = this;
        if (fields.length) {
            return (React.createElement(Button, { className: `${prefixCls}-professional-query-more`, funcType: FuncType.raised, onClick: () => this.openMore(fields) },
                $l('Table', 'more'),
                this.moreFields && this.moreFields.length ? React.createElement(Icon, { type: 'expand_less' }) : React.createElement(Icon, { type: 'expand_more' })));
        }
    }
    /**
     * 注入 onEnterDown 事件
     * @param elements
     */
    createFields(elements) {
        return elements.map(element => {
            const { onEnterDown } = element.props;
            if (onEnterDown && isFunction(onEnterDown)) {
                return element;
            }
            const props = {
                onEnterDown: this.handleFieldEnter,
            };
            return cloneElement(element, props);
        });
    }
    getQueryBar() {
        const { queryFieldsLimit, queryFields, queryDataSet, formProps } = this.props;
        const { prefixCls } = this;
        if (queryDataSet && queryFields.length) {
            const currentFields = (React.createElement(Form, Object.assign({ dataSet: queryDataSet, columns: queryFieldsLimit, labelTooltip: LabelTooltip.overflow, labelWidth: 80 }, formProps),
                this.createFields(this.queryFields.slice(0, queryFieldsLimit)),
                this.moreFields));
            const moreFields = this.createFields(this.queryFields.slice(queryFieldsLimit));
            const moreFieldsButton = this.getMoreFieldsButton(moreFields);
            let noVerticalFlag = false;
            const labelLayout = (formProps && formProps.labelLayout) || getConfig('labelLayout');
            if (labelLayout !== LabelLayout.vertical) {
                noVerticalFlag = true;
            }
            return (React.createElement("div", { key: "query_bar", className: `${prefixCls}-professional-query-bar` },
                currentFields,
                React.createElement("span", { className: classNames(`${prefixCls}-professional-query-bar-button`, {
                        [`${prefixCls}-professional-query-bar-button-vertical`]: !noVerticalFlag
                    }) },
                    moreFieldsButton,
                    this.getResetButton(),
                    React.createElement(Button, { color: ButtonColor.primary, wait: 500, onClick: () => this.handleQuery() }, $l('Table', 'query_button')))));
        }
    }
    handleQueryReset() {
        const { queryDataSet, autoQueryAfterReset, onReset = noop } = this.props;
        if (queryDataSet) {
            const { current } = queryDataSet;
            if (current) {
                current.reset();
                onReset();
                if (autoQueryAfterReset) {
                    this.handleQuery(true);
                }
            }
        }
    }
    render() {
        const { buttons, summaryBar } = this.props;
        const { prefixCls } = this;
        const queryBar = this.getQueryBar();
        const tableButtons = buttons.length ? (React.createElement("div", { key: "professional_toolbar", className: `${prefixCls}-professional-toolbar` },
            React.createElement(TableButtons, { key: "table_buttons", prefixCls: prefixCls, buttons: buttons }, summaryBar))) : (React.createElement("div", { className: `${prefixCls}-toolbar`, key: "professional_toolbar" }, summaryBar));
        return [queryBar, tableButtons];
    }
};
TableProfessionalBar.defaultProps = {
    queryFieldsLimit: 3,
    autoQueryAfterReset: true,
};
__decorate([
    observable
], TableProfessionalBar.prototype, "moreFields", void 0);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleDataSetValidate", null);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleFieldEnter", null);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleQuery", null);
__decorate([
    action
], TableProfessionalBar.prototype, "openMore", void 0);
__decorate([
    autobind
], TableProfessionalBar.prototype, "handleQueryReset", null);
TableProfessionalBar = __decorate([
    observer
], TableProfessionalBar);
export default TableProfessionalBar;
